import { https } from "../http";
import store from "../store";
import { setLoadingUserTracking } from "../store/reducers/userTracking";
import { showError } from "../utils";

const getUserTracking = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-today-tracking", data);
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getUserLatestTracking = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-todays-latest-tracking", data);
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const getHighAccuracyLocation = async  (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-accurate-location");
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const calculateDistanceMiles = async  (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/calculate-distance", data);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const tracking_clockin = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/clock-in", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const breakStart = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/break-start", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const breakEnd = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/break-end", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const tracking_clockout = async (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/clock-out", data);
    if (response?.status === 200) {
      // callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export { tracking_clockin, getUserTracking, tracking_clockout, getUserLatestTracking, breakStart, breakEnd };
